module.exports = __webpack_public_path__ + "img/hairdresser2.0495c944.webp";